import styled from 'styled-components'
import { FinanservsHorizontalLogoWhiteImg } from './images'
import { Nav } from './Nav'

const Div = styled.div`
    background-color: ${ ({ theme }) => theme.colors.blue };
    padding-top: 10px;
    padding-left: 20px;
`

const LayoutHeader = styled.header`
    display: grid;
    min-width: 100vh;
    height: 64px;
    grid-template-columns: auto 130px;

    grid-template-areas: 'logo menu';

    & .logo { grid-area: logo; }

    & .menu { grid-area: menu; }
`

const Header = () => {
    return (
        <LayoutHeader>
            <Div className="logo">
                <FinanservsHorizontalLogoWhiteImg />
            </Div>
            <div className="menu">
                <Nav />
            </div>
        </LayoutHeader>
    )
}

export default styled(Header)`
    text-align: center;
    padding: 1em 0;
    img {
        vertical-align: middle;
    }
`